
  <div class="tabs-container" *ngIf="loggedInUserRole != 'HR Admin'">
    <ion-row *ngIf="!router.url.includes('Setup')  " >
      <ion-col size="12">
        <div class="borderbottomForTab1" *ngIf="!router.url.includes('Setup')">
          <mat-tab-group #tabGroup class="pt-10 pr-10"
          (selectedTabChange)="tabTypeChanged($event)">
        
            <mat-tab label="Employee"
            *ngIf="!( loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD')">
            <ng-template mat-tab-label>
              <span style="display: contents;">
                <span class="material-icons mr-10">
                  person
                </span>My Report </span>
            </ng-template>
          </mat-tab>
          <mat-tab label="Manager"
          *ngIf=" (isFinanceLoginUser || loggedInUserRole == 'Manager' || loggedInHODManager == 'HODManager' ) && !(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD' ||loggedInUserRole=='Employee'  || approveMatrixValueForCondition=='EMPLOYEE_TO_FINANCE')" >
            <ng-template mat-tab-label>
              <span style="display: contents;">
                <span class="material-icons mr-10">
                  ads_click
                </span>Team Report </span>
            </ng-template>
          </mat-tab>
          <mat-tab label="Finance"
            *ngIf=" (isFinanceLoginUser || loggedInUserRole == 'HR Admin')">
            <ng-template mat-tab-label>
              <span style="display: contents;">
                <span class="material-icons mr-10">
                  ads_click
                </span>Finance Report</span>
            </ng-template>
          </mat-tab>
          </mat-tab-group>
        </div>
      </ion-col>
    </ion-row>
  <!-- <div class="card"></div> -->
</div>

<div class="">
  <ion-row>
    <!-- Left Section: Filters & Search -->
    <ion-col size="12" size-md="9">
   
       <!-- Finance Dropdown -->
      <mat-form-field class="w-100 mw-sm-250 mt-10 mat-height40 mat-input-style mr-15"  *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin'">
        <mat-select
          class="centered-label"
          name="reimbursementSelect"
          [(ngModel)]="financeIdForEmployee"
          (selectionChange)="getFinaceForReimbursement($event.value)">
          <mat-option [value]="-1">Select All Finance </mat-option>
          <mat-option *ngFor="let item of fitergetAllFinanceUserDD" [value]="item.id">
            {{ item.firstName }} {{ item.lastName }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <!-- Date Range Filter -->
     
  
      <!-- Fiscal Year Dropdown (only when fiscal is selected) -->
      <mat-form-field class="w-100 mw-sm-250 mt-10 mat-height40 mat-input-style"
                      *ngIf="selectedOptionReportOne === 'fiscal'">
        <mat-select placeholder="Select"
                    [(ngModel)]="selectedYearForCompetency"
                    (selectionChange)="viewReimbursementReportByYear($event.value)">
          <mat-option [value]="item.year" *ngFor="let item of pmsYears">
            {{ sharedService.transformYearToFyFormat(item.year) }}
          </mat-option>
        </mat-select>
      </mat-form-field>
  
    </ion-col>
  
    <!-- Right Section: Actions -->
    <ion-col size="12" size-md="3" class="ion-text-md-end">
      
      <!-- Refresh Icon -->
      <span 
        class="ml-5 mt-10 fs-20 material-icons btn-reset"
        style="cursor:pointer;"
        [class.clicked]="isClicked"
        (click)="resetGrid(); isClicked = true"
        (animationend)="isClicked = false">
        refresh
      </span>
  
      <!-- Download Icon -->
      <span 
        class="ml-5 mt-10 fs-20 material-icons icon-download"
        style="cursor:pointer;"
        (click)="onBtExport()">
        download
      </span>
  
    </ion-col>
  </ion-row>
  
  <!------------------------------------------------------- HR Login ------------------------------------------------>

  <div class="card  employeeTab">
    <div *ngIf="selectedTypeTabName=='Finance' || loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin'">

        <mat-sidenav-container style="height: 100%;">
          <!-- Main Content with AG Grid -->
          <mat-sidenav-content>
            <ag-grid-angular
              style="width: 100%; height: 600px;"
              class="ag-theme-quartz"
              [rowData]="allTeamMemberReimbursementApprove"
              [columnDefs]="taskColumnHeaderInfoForFinanse"
              [gridOptions]="gridOptions"
              [defaultColDef]="defaultColDef"
              (gridReady)="onGridReady($event)"
              (rowClicked)="onRowClicked($event)"
              [pagination]="pagination"
              [paginationPageSize]="paginationPageSize"
              [paginationPageSizeSelector]="paginationPageSizeSelector"
              [detailRowAutoHeight]="detailRowAutoHeight"
              [localeText]="{ noRowsToShow: 'No Data Found' }"
            >
            </ag-grid-angular>
          </mat-sidenav-content>
          
       
          <!-- Right Side Sidenav -->
          <mat-sidenav #detailsPanel mode="over" position="end" [(opened)]="isDetailsOpen" class="details-panel">
            <!-- HEADER -->
            <div class="details-header">
              <h2>Reimbursement Details</h2>
              <button mat-icon-button (click)="closeDetails()">
                <mat-icon class="close-icon">close</mat-icon>
              </button>
            </div>
          
            <!-- CONTENT -->
            <div class="details-content" *ngIf="selectedRow">
              <mat-card class="detail-card" *ngFor="let col of taskColumnHeaderInfoForFinanse">
                <mat-card-content>
                  <div class="detail-row">
                    <mat-icon class="detail-icon">trending_flat</mat-icon>
                    <div class="detail-text">
                      
                      <!-- LABEL -->
                      <span class="detail-label">{{ col.headerName }} </span>
          
                      <!-- STATUS BADGE -->
                      <ng-container *ngIf="col.headerName === 'Status'; else approvalCheck">
                        <span class="status-badge"
                              [ngClass]="{
                                'approved': selectedRow[col.field]?.toUpperCase().includes('APPROVED'),
                                'rejected': selectedRow[col.field]?.toUpperCase().includes('REJECTED'),
                                'pending': selectedRow[col.field]?.toUpperCase().includes('PENDING')
                              }">
                          {{ formatStatus(selectedRow[col.field]) }}
                        </span>
                      </ng-container>
          
                      <!-- APPROVAL BADGE -->
                      <ng-template #approvalCheck>
                        <ng-container *ngIf="col.headerName === 'Approval'; else normalContent">
                          <span class="status-badge"
                                [ngClass]="{
                                  'approved': selectedRow[col.field] === 'APPROVED',
                                  'rejected': selectedRow[col.field] === 'REJECTED',
                                  'pending': selectedRow[col.field] === 'PENDING'
                                }">
                            {{ formatStatus(selectedRow[col.field]) }}
                          </span>
                        </ng-container>
                      </ng-template>
          
                      <!-- NORMAL DATA / DOCUMENT -->
                      <ng-template #normalContent>
                        <ng-container *ngIf="col.field === 'uploadDocument'; else textValue">
                          <ng-container *ngIf="selectedRow[col.field]; else noFile">
                            <img src="assets/icon/yellowdownload.png"
                                alt="download"
                                width="18" height="18"
                                style="cursor:pointer"
                                (click)="openFile(downloadDialogRenderer(selectedRow[col.field]))"
                            />
                          </ng-container>
                          <ng-template #noFile>
                            <span></span>
                          </ng-template>
                        </ng-container>
          
                        <ng-template #textValue>
                          <span>
                            {{ (col.field === 'date' || col.field === 'dateOfExpense') 
                                ? formatDate(selectedRow[col.field]) 
                                : selectedRow[col.field] || selectedRow[col.field]}}
                          </span>
                        </ng-template>
                        
                      </ng-template>
          
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </mat-sidenav>
        </mat-sidenav-container>
    </div>
  </div>
  <!-- ---------------------------------------------------------Employee-------------------------------------------------------------------- -->

  <div class="card  employeeTab"*ngIf="selectedTypeTabName =='Employee' && (loggedInUserRole != 'HR Admin' && loggedInUserRole != 'Super Admin')">

    <div class="card-body">
      <!-- <div> -->

        <!-- <div class="p-10"> -->
          <mat-sidenav-container style="height: 100%;">
            <!-- Main Content with AG Grid -->
            <mat-sidenav-content>
              <ag-grid-angular
                style="width: 100%; height: 600px;"
                class="ag-theme-quartz"
                [rowData]="tableDataDetails"
                [columnDefs]="taskColumnHeaderInfo"
                [gridOptions]="gridOptions"
                [defaultColDef]="defaultColDef"
                (gridReady)="onGridReady($event)"
                (rowClicked)="onRowClicked($event)"
                [pagination]="pagination"
                [paginationPageSize]="paginationPageSize"
                [paginationPageSizeSelector]="paginationPageSizeSelector"
                [detailRowAutoHeight]="detailRowAutoHeight"
                [localeText]="{ noRowsToShow: 'No Data Found' }"
              >
              </ag-grid-angular>
            </mat-sidenav-content>
            <!-- Right Side Sidenav -->
            <mat-sidenav #detailsPanel mode="over" position="end" [(opened)]="isDetailsOpen" class="details-panel">
              <!-- HEADER -->
              <div class="details-header">
                <h2>Reimbursement Details</h2>
                <button mat-icon-button (click)="closeDetails()">
                  <mat-icon class="close-icon">close</mat-icon>
                </button>
              </div>
            
              <!-- CONTENT -->
              <div class="details-content" *ngIf="selectedRow">
                <mat-card class="detail-card" *ngFor="let col of taskColumnHeaderInfo">
                  <mat-card-content>
                    <div class="detail-row">
                      <mat-icon class="detail-icon">trending_flat</mat-icon>
                      <div class="detail-text">
                        
                        <!-- LABEL -->
                        <span class="detail-label">{{ col.headerName }}</span>
            
                        <!-- STATUS BADGE -->
                        <ng-container *ngIf="col.headerName === 'Status'; else approvalCheck">
                          <span class="status-badge"
                                [ngClass]="{
                                  'approved': selectedRow[col.field]?.toUpperCase().includes('APPROVED'),
                                  'rejected': selectedRow[col.field]?.toUpperCase().includes('REJECTED'),
                                  'pending': selectedRow[col.field]?.toUpperCase().includes('PENDING')
                                }">
                            {{ formatStatus(selectedRow[col.field]) }}
                          </span>
                        </ng-container>
            
                        <!-- APPROVAL BADGE -->
                        <ng-template #approvalCheck>
                          <ng-container *ngIf="col.headerName === 'Approval'; else normalContent">
                            <span class="status-badge"
                                  [ngClass]="{
                                    'approved': selectedRow[col.field] === 'APPROVED',
                                    'rejected': selectedRow[col.field] === 'REJECTED',
                                    'pending': selectedRow[col.field] === 'PENDING'
                                  }">
                              {{ formatStatus(selectedRow[col.field]) }}
                            </span>
                          </ng-container>
                        </ng-template>
            
                        <!-- NORMAL DATA / DOCUMENT -->
                        <ng-template #normalContent>
                          <ng-container *ngIf="col.field === 'uploadDocument'; else textValue">
                            <ng-container *ngIf="selectedRow[col.field]; else noFile">
                              <img src="assets/icon/yellowdownload.png"
                                  alt="download"
                                  width="18" height="18"
                                  style="cursor:pointer"
                                  (click)="openFile(downloadDialogRenderer(selectedRow[col.field]))"
                              />
                            </ng-container>
                            <ng-template #noFile>
                              <span></span>
                            </ng-template>
                          </ng-container>
                          
            
                          <ng-template #textValue>
                            <span>
                              {{ (col.field === 'date' || col.field === 'dateOfExpense') 
                                ? formatDate(selectedRow[col.field]) 
                                : selectedRow[col.field] || selectedRow[col.field]}}
                            </span>
                          </ng-template>
                        </ng-template>
            
                      </div>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
            </mat-sidenav>
          </mat-sidenav-container>
           
        <!-- </div> -->
      <!-- </div> -->
    </div>
  </div>

  <!-------------------------------------------------------Manager Login ------------------------------------------------>
 
  <div class="card employeeTab">

    <div *ngIf="selectedTypeTabName=='Manager' && (loggedInUserRole != 'HR Admin' && loggedInUserRole != 'Super Admin')">
      
      <mat-sidenav-container style="height: 100%;">
        <!-- Main Content with AG Grid -->
        <mat-sidenav-content>
          <ag-grid-angular
            style="width: 100%; height: 600px;"
            class="ag-theme-quartz"
            [rowData]="allTeamReimbursement"
            [columnDefs]="taskColumnHeaderInfoForManager"
            [gridOptions]="gridOptions"
            [defaultColDef]="defaultColDef"
            (gridReady)="onGridReady($event)"
            (rowClicked)="onRowClicked($event)"
            [pagination]="pagination"
            [paginationPageSize]="paginationPageSize"
            [paginationPageSizeSelector]="paginationPageSizeSelector"
            [detailRowAutoHeight]="detailRowAutoHeight"
            [localeText]="{ noRowsToShow: 'No Data Found' }"
          >
          </ag-grid-angular>
        </mat-sidenav-content>
        <!-- Right Side Sidenav -->
        <mat-sidenav #detailsPanel mode="over" position="end" [(opened)]="isDetailsOpen" class="details-panel">
          <!-- HEADER -->
          <div class="details-header">
            <h2>Reimbursement Details</h2>
            <button mat-icon-button (click)="closeDetails()">
              <mat-icon class="close-icon">close</mat-icon>
            </button>
          </div>
        
          <!-- CONTENT -->
          <div class="details-content" *ngIf="selectedRow">
            <mat-card class="detail-card" *ngFor="let col of taskColumnHeaderInfoForManager">
              <mat-card-content>
                <div class="detail-row">
                  <mat-icon class="detail-icon">trending_flat</mat-icon>
                  <div class="detail-text">
                    
                    <!-- LABEL -->
                    <span class="detail-label">{{ col.headerName }}</span>
        
                    <!-- STATUS BADGE -->
                    <ng-container *ngIf="col.headerName === 'Status'; else approvalCheck">
                      <span class="status-badge"
                            [ngClass]="{
                              'approved': selectedRow[col.field]?.toUpperCase().includes('APPROVED'),
                              'rejected': selectedRow[col.field]?.toUpperCase().includes('REJECTED'),
                              'pending': selectedRow[col.field]?.toUpperCase().includes('PENDING')
                            }">
                        {{ formatStatus(selectedRow[col.field]) }}
                      </span>
                    </ng-container>
        
                    <!-- APPROVAL BADGE -->
                    <ng-template #approvalCheck>
                      <ng-container *ngIf="col.headerName === 'Approval'; else normalContent">
                        <span class="status-badge"
                              [ngClass]="{
                                'approved': selectedRow[col.field] === 'APPROVED',
                                'rejected': selectedRow[col.field] === 'REJECTED',
                                'pending': selectedRow[col.field] === 'PENDING'
                              }">
                          {{ formatStatus(selectedRow[col.field]) }}
                        </span>
                      </ng-container>
                    </ng-template>
        
                    <!-- NORMAL DATA / DOCUMENT -->
                    <ng-template #normalContent>
                      <ng-container *ngIf="col.field === 'uploadDocument'; else textValue">
                        <ng-container *ngIf="selectedRow[col.field]; else noFile">
                          <img src="assets/icon/yellowdownload.png"
                              alt="download"
                              width="18" height="18"
                              style="cursor:pointer"
                              (click)="openFile(downloadDialogRenderer(selectedRow[col.field]))"
                          />
                        </ng-container>
                        <ng-template #noFile>
                          <span></span>
                        </ng-template>
                      </ng-container>
                      
        
                      <ng-template #textValue>
                        <span>
                          {{ (col.field === 'date' || col.field === 'dateOfExpense') 
                                ? formatDate(selectedRow[col.field]) 
                                : selectedRow[col.field] || selectedRow[col.field]}}
                        </span>
                      </ng-template>
                    </ng-template>
        
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </mat-sidenav>
      </mat-sidenav-container>
 
    </div>
  </div>
</div>